import Intellibrand from './Intellibrand';
import _ from 'lodash';

var win = $(window);
var isMobile = win.width() < 850;

$(document).ready(function() {
  if(window.pompom_current_page !== 'comprar') return;
  
  let win = $(window);
  let elBody = $('html,body');
  /////////////////////////////////////////////////////////////////////////////////
  // Swipers do topo
  $('.swiper-header-products').each(function() {
    let elRoot = $(this);
    let elSwipe = elRoot.find('.swiper-container');
    let elArrowLeft = elRoot.find('.section-header-arrow.left');
    let elArrowRight = elRoot.find('.section-header-arrow.right');
    let elSwipePagination = elSwipe.find('.swiper-pagination');

    // Criar o slideshow
    let swipeInstance = new Swiper(elSwipe[0], {
      slidesPerView: 1,
      // spaceBetween: 20,
      pagination: {
        el: elSwipePagination,
        clickable: true,
      }
    });

    // Bind setinhas
    elArrowLeft.on('click', () => {
      console.log('slidePrev');
      swipeInstance.slidePrev();
    });
    elArrowRight.on('click', () => {
      console.log('slideNext');
      swipeInstance.slideNext();
    });

    // Desativar setinhas quando chegar no limite
    swipeInstance.on('slideChange', () => {
      // console.log('slideChange: ', swipeInstance.realIndex, swipeInstance.slides.length);
      if(swipeInstance.realIndex === 0) {
        elArrowLeft.addClass('disabled');
      } else {
        elArrowLeft.removeClass('disabled');
      }

      if(swipeInstance.realIndex === swipeInstance.slides.length - 1) {
        elArrowRight.addClass('disabled');
      } else {
        elArrowRight.removeClass('disabled');
      }
    });

    // Bind Botões Comprar
    elRoot.find('[data-set-filtro]').click(function() {
      let farr = $(this).data('set-filtro').split(':');
      let ftype = farr[0];
      let findex = farr[1];
      $($('#filters-'+ftype+' .section-level-1 [data-set-subsection]')[findex]).click();
      elBody.animate({ scrollTop: $('.heart-tabs-js').offset().top + 50 });
    });

    elArrowLeft.addClass('disabled');
  });

  /////////////////////////////////////////////////////////////////////////////////
  // TABS:     Fraldas  Cuidados com o bebê
  (function() {
    let elRoot = $('.heart-tabs-js');
    let elHeart = elRoot.find('.blue-heart');
    let elTabs = elRoot.find('.heart-tab-js-li');
    let heartWidth = 18;

    let moveHeartToTab = function(tab) {
      let tabLeft = tab.offset().left;
      let tabWidth = tab.width();
      let horizTotalPadding = 0;
      elHeart.css({
        left: tabLeft + ((tabWidth + horizTotalPadding) / 2) - (heartWidth / 2)
      });
    };

    elTabs.on('click', function() {
      let elActiveTab = $(this);
      moveHeartToTab(elActiveTab);
      elTabs.removeClass('active');
      elActiveTab.addClass('active');

      let visibleId = elActiveTab.data('set-visible-id');
      if(visibleId) {
        $('[data-visible-id]').hide();
        $('[data-visible-id="'+ visibleId +'"]').fadeIn();

        if(isMobile) {
          $('#filters-'+visibleId+'-mobile .section-level-2 .filter-select').trigger('change');
        } else {
          $($('#filters-'+visibleId+' .section-level-2 [data-eans]')[0]).click();
        }
      }
    });
    $(elTabs[0]).click();

    let delayHeart = _.debounce(function() {
      moveHeartToTab($('.heart-tab-js-li.active'));
    }, 500);

    window.addEventListener('resize', delayHeart);
  }());

  /////////////////////////////////////////////////////////////////////////////////
  // Conteúdo - Lista de Produtos
  let elContent = $('#products-list');
  function setContentLoading() {
    elContent.html('<div class="comprar-content-loading">Pesquisando Produtos</div>');
  }
  function setContentError(erro) {
    elContent.html('<div class="comprar-content-error">'+erro+'</div>');
  }
  function setContentZero() {
    elContent.html('<div class="comprar-content-zero">Não encontramos nenhuma oferta atualmente para este produto</div>');
  }
  function dez(n) {
    return parseInt(n) > 9 ? ''+n : '0'+parseInt(n);
  }
  function formatPrice(priceNum) {
    let priceArr = (priceNum+'').split('.');
    return priceArr[0] + ',' + dez(priceArr[1] || 0);
  }
  function setContentOffers(offers) {
    if(!offers || !Array.isArray(offers) || !offers.length) return setContentZero();

    let arrOffers = [];

    offers.forEach(function(offer) {
      let pricingHtml = '';

      if(offer.price) {
        pricingHtml = `<div class="product-item-pricing">
          <span class="pricing-label">a partir de</span>
          <span class="pricing-value">R$${formatPrice(offer.price)}</span>
        </div>`;
      }

      let oProduct = offer.product || {};

      arrOffers.push(`<div class="product-item">
        <div class="product-item-img">
          <div class="product-item-img-bg" style="background-image: url('${oProduct.image}');"></div>
        </div>
        <div class="product-item-content">
          <div class="product-item-title">${oProduct.name}</div>
          <div class="product-item-description">${oProduct.description}</div>
          ${pricingHtml}
          <div class="product-item-button">
            <a href="${offer.url}" target="_blank" class="highlight-button">Comprar</a>
          </div>
        </div>
      </div>`);
    });

    elContent.html(arrOffers.join(' '));
  }

  /////////////////////////////////////////////////////////////////////////////////
  // Filtros Desktop
  (function() {
    /////////////////////////////////////////
    // Mover o coração azul
    function setActiveTab(elRoot, elLink) {
      let elSelector = elRoot.find('.heart-filters-selector');
      let elLinks = elRoot.find('li');
      let relTop = elRoot.offset().top;
      elLinks.removeClass('active');
      elSelector.css({
        top: elLink.offset().top - relTop - 37 + 5
      });
      elLink.addClass('active');
    }

    /////////////////////////////////////////
    // Primeiro Filtro (section)
    function makeSection(elem, section, openFirstItem) {
      elem.html('');
      if(!section) return;
      section.forEach(function(filterSection) {
        let leLinks = '';
  
        filterSection.sectionOptions.forEach(function(filterItem) {
          let active = leLinks ? '' : 'class="active"';
          leLinks += '<li data-set-subsection=\'' + JSON.stringify(filterItem.subsection) + '\' '+active+'>\
            <span>'+filterItem.label+'</span>\
          </li>';
        });
  
        elem.append('\
          <div class="filter-section section-level-1">\
            <div class="filter-title">' + filterSection.sectionTitle + ':</div>\
            <div class="heart-filters">\
              <div class="heart-filters-selector blue-heart"></div>\
              <div class="heart-filters-selector-bg"></div>\
              <ul>\
                ' + leLinks + '\
              </ul>\
            </div>\
          </div>\
        ');
  
        makeSubsection(elem, filterSection.sectionOptions[0].subsection, openFirstItem);
      });

      elem.find('.section-level-1 li').on('click', function() {
        let elTab = $(this);
        setActiveTab(elem.find('.section-level-1'), elTab);
        makeSubsection(elem, elTab.data('set-subsection'), true);
      });

      // @ START RESIZE
      let delayActiveTab = _.debounce(function() {
        setActiveTab(elem.find('.section-level-1'), elem.find('.section-level-1 li.active'));
      }, 500);
      window.addEventListener('resize', delayActiveTab);
      // @ END RESIZE
    };

    /////////////////////////////////////////
    // Segundo Filtro (subsection)
    function makeSubsection(elem, subsection, openFirstItem) {
      // console.log('makeSubsection ', subsection);
      let leLinks = '';

      elem.find('.section-level-2').remove();

      subsection.sectionOptions.forEach(function(filterItem) {
        let active = leLinks ? '' : 'class="active"';
        leLinks += '<li data-eans=\'' + JSON.stringify(filterItem.eans) + '\' '+active+'>\
          <span>'+filterItem.label+'</span>\
        </li>';
      });

      elem.append('\
        <div class="filter-section section-level-2">\
          <div class="filter-title">' + subsection.sectionTitle + ':</div>\
          <div class="heart-filters">\
            <div class="heart-filters-selector blue-heart"></div>\
            <div class="heart-filters-selector-bg"></div>\
            <ul>\
              ' + leLinks + '\
            </ul>\
          </div>\
        </div>\
      ');

      elem.find('.section-level-2 li').on('click', function() {
        let elTab = $(this);
        // console.log('eans::::: ', elTab.data('eans'));
        setActiveTab(elem.find('.section-level-2'), elTab);
        // let eans = JSON.parse(elTab.data('eans'));
        let eans = elTab.data('eans');
        // console.log('search Eans: ', eans);
        setContentLoading();
        Intellibrand.API.searchMultipleEans(eans).then(response => {
          if(response && response.data && response.data.offers) {
            console.log('offers: ', response.data.offers);
            setContentOffers(response.data.offers);
          } else {
            setContentError(response && response.error_description || 'Ocorreu um erro ao pesquisar produtos');
          }
        });
      });

      // @ START RESIZE
      let delayActiveTab = _.debounce(function() {
        setActiveTab(elem.find('.section-level-2'), elem.find('.section-level-2 li.active'));
      }, 500);
      window.addEventListener('resize', delayActiveTab);
      // @ END RESIZE

      if(openFirstItem) $(elem.find('.section-level-2 li')[0]).click();
    };


    setContentLoading();
    makeSection($('#filters-fraldas'), Intellibrand.filtroFraldasData, true);
    makeSection($('#filters-outros'), Intellibrand.filtroOutrosData);
    // $($('#filters-fraldas .section-level-2 [data-eans]')[0]).click();
  }());

  /////////////////////////////////////////////////////////////////////////////////
  // Filtros Mobile
  (function() {
    /////////////////////////////////////////
    // Primeiro Filtro (select)
    function makeSectionMobile(elem, section, openFirstItem) {
      elem.html('');
      if(!section) return;
      section.forEach(function(filterSection) {
        let leOptions = '';
  
        filterSection.sectionOptions.forEach(function(filterItem) {
          leOptions += '<option value=\'' + JSON.stringify(filterItem.subsection) + '\'>\
            '+filterItem.label+'\
          </li>';
        });
  
        elem.append('\
          <div class="filter-section-mobile section-level-1">\
            <div class="filter-title">' + filterSection.sectionTitle + ':</div>\
            <select class="filter-select">\
              ' + leOptions + '\
            </select>\
          </div>\
        ');

        elem.find('.section-level-1 .filter-select').on('change', function() {
          makeSubsectionMobile(elem, JSON.parse($(this).val()), true);
        }).selectric();
  
        makeSubsectionMobile(elem, filterSection.sectionOptions[0].subsection, openFirstItem);
      });
    };
    /////////////////////////////////////////
    // Segundo Filtro (select)
    function makeSubsectionMobile(elem, subsection, openFirstItem) {
      // console.log('makeSubsection ', subsection);
      let leOptions = '';

      elem.find('.section-level-2').remove();

      subsection.sectionOptions.forEach(function(filterItem) {
        leOptions += '<option value=\'' + JSON.stringify(filterItem.eans) + '\'>\
          '+filterItem.label+'\
        </option>';
      });

      elem.append('\
        <div class="filter-section-mobile section-level-2">\
          <div class="filter-title">' + subsection.sectionTitle + ':</div>\
          <select class="filter-select">\
            ' + leOptions + '\
          </select>\
        </div>\
      ');

      elem.find('.section-level-2 .filter-select').on('change', function() {
        let eans = JSON.parse($(this).val());
        // console.log('eans:::: ', eans);
        setContentLoading();
        Intellibrand.API.searchMultipleEans(eans).then(response => {
          if(response && response.data && response.data.offers) {
            console.log('offers: ', response.data.offers);
            setContentOffers(response.data.offers);
          } else {
            setContentError(response && response.error_description || 'Ocorreu um erro ao pesquisar produtos');
          }
        });
      }).selectric();

      // elem.find('.section-level-2 li').on('click', function() {
      //   let elTab = $(this);
      //   // console.log('eans::::: ', elTab.data('eans'));
      //   setActiveTab(elem.find('.section-level-2'), elTab);
      //   // let eans = JSON.parse(elTab.data('eans'));
      //   let eans = elTab.data('eans');
      //   // console.log('search Eans: ', eans);
      //   setContentLoading();
      //   Intellibrand.API.searchMultipleEans(eans).then(response => {
      //     if(response && response.data && response.data.offers) {
      //       console.log('offers: ', response.data.offers);
      //       setContentOffers(response.data.offers);
      //     } else {
      //       setContentError(response && response.error_description || 'Ocorreu um erro ao pesquisar produtos');
      //     }
      //   });
      // });

      if(openFirstItem) elem.find('.section-level-2 .filter-select').trigger('change');
    };

    setContentLoading();
    makeSectionMobile($('#filters-fraldas-mobile'), Intellibrand.filtroFraldasData);
    makeSectionMobile($('#filters-outros-mobile'), Intellibrand.filtroOutrosData);
  }());
});
